import React from 'react';
import { ErrorLayout } from '@axiom/ui';

export const UnauthorizedPage = () => (
  <div data-test="UNAUTHORIZED_PAGE">
    <ErrorLayout
      name="ERROR_BOUNDARY_LAYOUT"
      errorMessage="You are not authorized to view this page."
    />
  </div>
);
